import { FunctionComponent } from "react";

const Dictionary: FunctionComponent = () => {
  return (
    <div className="relative w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[6.25rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito"
    style={{
      backgroundColor: '#0d0d0d'
    }}
    >
      <div className="still self-stretch flex flex-row items-center justify-between text-[1.5rem] text-white">
        <img
          className="abs relative w-[3.75rem] h-[3.79rem] object-cover"
          alt=""
          src="/nav@2x.png"
        />
        <a href="https://unityacademy.io/dashboard" className="flex-1 text-white no-underline rounded-[26px] bg-transparent box-border h-[4.06rem] flex flex-col items-center justify-center min-w-[9.38rem] max-w-[18.75rem] border-[2px] border-solid border-white">
        <div >
          <div className="relative font-semibold">Back to Home</div>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-row items-center justify-between">
       
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Trading Dictionary
          </b>
        </div>
        
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[6.88rem] max-w-[102.63rem] text-justify text-gainsboro-100 font-dm-sans">
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-1@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Arbitrage Profit `}</b>
            <span>
              - The return of a trade where the currency is bought from the
              exchange with the lowest ask and sold in the exchange with the
              highest bid. If positive, an arbitrage opportunity has been
              detected.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Accumulation/Distribution Indicator</b>
            <span>
              {" "}
              - The accumulation/distribution indicator determines the supply
              and demand level of a stock/asset/cryptocurrency by multiplying
              the closing price of a specific period with volume.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Address</b>
            <span>
              {" "}
              - Also referred to as "wallet address". It is a place where
              cryptocurrency can be sent to and from, in the form of a string of
              letters and numbers.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Adoption Curve</b>
            <span>
              {" "}
              - indicates the pace of adoption of a new technology by the
              public.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Airdrop</b>
            <span>
              {" "}
              - marketing campaign that distributes a specific cryptocurrency or
              token for free to an audience. Can be to promote new currencies or
              act as a reward system.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Avatar</b>
            <span>
              {" "}
              - Avatars are forms of Generative Art, typically created into a
              collection of NFTs. E.G 10,000 Cryptopunks.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`ADA `}</b>
            <span>- ADA is the cryptocurrency for the Cardano Blockchain.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Adoption</b>
            <span>
              {" "}
              - If you adopt something, you are deciding to follow, use or take
              it up. Adoption in this sense refers to the rate of adoption on a
              macro scale. Is the adoption (usage) or cryptocurrency rising in
              recent months? Yes.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Appreciate `}</b>
            <span>
              - A value increase. E.G bitcoin appreciated in value by 2.4% in
              the last 24 hours.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Asset `}</b>
            <span>
              - An item of property owned by a person or company, regarded as
              having value. E.G an NFT.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Algo-Trading (Algorithmic Trading) `}</b>
            <span>
              - an automated trading system where buy and sell orders are placed
              based on the specific rules of a computer program or algorithm.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Algorithm `}</b>
            <span>
              - A process or set of rules to be followed in problem-solving or
              calculation operations, usually by a computer.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`ATH (All Time High) `}</b>
            <span>
              - The highest point (in price, in market capitalization) that a
              cryptocurrency has ever been in its history.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">ATL (All Time Low)</b>
            <span>
              {" "}
              - The lowest point (in price, in market capitalization) that a
              cryptocurrency has been in its history.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Altcoin</b>
            <span>
              {" "}
              - Any coin other than Bitcoin are known as this referring to
              “alternative coins.”
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Apeing</b>
            <span>
              {" "}
              - refers to when a crypto trader blindly buys a token immediately
              after the token project launch without conducting any research.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">ASIC</b>
            <span>
              {" "}
              - short for application-specific integrated circuit which is a
              device designed solely for mining cryptocurrencies.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Asset-Backed Tokens `}</b>
            <span>
              - Digital claims on a physical asset that are backed by that
              asset.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">AUM (Assets Under Management)</b>
            <span>
              {" "}
              - Measures the total market values of all the funds controlled by
              an individual or financial institution on behalf of their clients.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Atomic Swap `}</b>
            <span>
              - Transfer of cryptocurrency from one party to another, without
              the use of an exchange or other intermediary.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-2@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Bear `}</b>
            <span>
              - "bearish"- Someone who believes prices in a given market will
              decline over a certain period.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Bearwhale</b>
            <span>
              {" "}
              - someone who has a high number of cryptocurrencies and uses their
              massive account to drive the price down and profit from it.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Benchmark</b>
            <span>
              {" "}
              - Benchmarking is a method of comparing the performance of your
              asset or investment portfolio to that of similar assets to see
              whether there is a gap that can be bridged by increasing certain
              performance indicators.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Benchmark Index `}</b>
            <span>
              - popular index security that is used as a gauge or benchmark,
              against which the progress of the broader market may be tracked.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Beta (Release) `}</b>
            <span>{`- Anything in a pre-release stage where its access is offered to a set number of users & third-party software testers for testing it under real-world settings.`}</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>BTM (Bitcoin ATM)</b>
            <span>
              {" "}
              - An automated teller machine (ATM or cashpoint) that allows the
              user to buy and sell Bitcoin.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>BTCD (Bitcoin Dominance)</b>
            <span>
              {" "}
              - a metric that determines how much share of the overall crypto
              market share is owned by Bitcoin.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Bid-Ask Spread `}</b>
            <span>
              - the amount by which the ask price exceeds the bid price for
              cryptos in the market.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Bitcointalk `}</b>
            <span>
              - the most popular online forum dedicated to Bitcoin,
              cryptocurrency and blockchain technology.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Bits `}</b>
            <span>
              - A commonly used unit, or subdivision, of a single Bitcoin.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Binance</b>
            <span>
              {" "}
              - An exchange that can be used to buy, sell and trade
              cryptocurrency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Bitcoin `}</b>
            <span>
              - a type of digital currency in which a record of transactions is
              maintained and new units of currency are generated by the
              computational solution of mathematical problems, and which
              operates independently of a central bank.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Black Swan Event</b>
            <span>
              {" "}
              - also known as black swan occurrences, is a metaphor for an
              unexpected event that has a significant impact.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Block</b>
            <span>
              {" "}
              - A data file containing information on transactions completed
              during a given time period. Blocks are the constituent parts of a
              blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Block Explorer</b>
            <span>
              {" "}
              - An application enabling a user to view details of blocks on a
              given blockchain. Also known as a blockchain browser.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Block Header</b>
            <span>
              {" "}
              - Unique identifier for a block on a blockchain that is hashed on
              a continual basis to supply proof-of-work to incentivize mining.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Block Height `}</b>
            <span>
              - Value describing the number of blocks preceding a given block in
              the blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>BP (Block Producer)</b>
            <span>
              {" "}
              - A person or group whose hardware is chosen to verify a block's
              transactions and begin the next block on most Proof-of-Stake (PoS)
              blockchains.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Block Reward</b>
            <span>
              {" "}
              - The coins awarded to a miner or group of miners for solving the
              cryptographic problem required to create a new block on a given
              blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Block Size</b>
            <span>
              {" "}
              - the amount of data about transactions a single block in the
              chain can carry.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Block Time `}</b>
            <span>
              - Refers to the approximate time it takes for a blockchain-based
              system to produce a new block.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Block Trade</b>
            <span>
              {" "}
              - a large-scale purchase or sale of securities that occur outside
              of an open market.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Blockchain</b>
            <span>
              {" "}
              - A distributed ledger system. A sequence of blocks, or units of
              digital information, stored consecutively in a public database.
              The basis for cryptocurrencies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Blockchain 1.0</b>
            <span>
              {" "}
              - The first generation of blockchain technology, which focuses on
              cryptocurrency and decentralization.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Blockchain 2.0 `}</b>
            <span>
              - An extension to blockchain 1.0, known for introducing the
              concept of decentralization of business and markets through smart
              contracts and improved security and transparency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Blockchain 3.0</b>
            <span>
              {" "}
              - The final developmental stage of blockchain technology, which
              predicts global, institutional and enterprise adoption.
            </span>
          </p>
          <p className="m-0">
            <b className="font-dm-sans">{`Blockchain Explorer `}</b>
            <span>
              - search engine allowing users to browse through blockchain
              records.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Bots `}</b>
            <span>
              - Automated software that can carry out tasks such as
              cryptocurrency trades.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>BFA (Brute Force Attack)</b>
            <span>
              {" "}
              - Attempt to crack a password or key through automated trial and
              error.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Bubble</b>
            <span>
              {" "}
              - Common term referring to when an asset is trading at a price
              exceeding that asset's intrinsic value.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Bull</b>
            <span>
              {" "}
              -"Bullish" - Someone that is extremely optimistic and confident
              that market prices will increase within a certain period of time.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Burn/Burned</b>
            <span>
              {" "}
              - Cryptocurrency tokens or coins that have been purposely and
              permanently removed from market circulation.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>BTD/ BTFD (Buy The F*** Dip)</b>
            <span>
              {" "}
              - Very commonly used by supporters of a cryptocurrency to buy in
              while prices are at a low point.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Buy Wall `}</b>
            <span>
              - an unusually large "buy limit order" placed on a cryptocurrency
              exchange.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-3@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Cardano</b>
            <span>
              {" "}
              - Cardano is a public blockchain platform. It is open-source and
              decentralized, with consensus achieved using proof of stake. It
              can facilitate peer-to-peer transactions with its internal
              cryptocurrency, Ada.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Capital</b>
            <span>
              {" "}
              - most commonly defined as the large sum of money you would use to
              invest.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Casascius Coin</b>
            <span>
              {" "}
              - physical unit of Bitcoin in the form of brass, silver or
              gold-plated coins.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`CeDeFi (centralized decentralized finance) `}</b>
            <span>{`- combines traditional centralized financial services with decentralized applications, `}</span>
          </p>
          <p className="m-0">
            merging conventional regulatory policies with modern financial
            products and infrastructure.
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Central Bank `}</b>
            <span>
              - In most modern economies, the central bank is responsible for
              the formulation and transmission of monetary policy, as well as
              for the regulation of member banks.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>CBDCs (Central Bank Digital Currency)</b>
            <span>
              {" "}
              - digital currencies issued by a central bank whose status as
              legal tender depends on government regulation or law.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Central Ledger</b>
            <span>
              {" "}
              - A physical book or a computer file used to record transactions
              in a centralized manner.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Central Processing Unit (CPU)</b>
            <span>
              {" "}
              - part of a computer that is in charge of interpreting and
              executing programs and coordinating the work of all other
              components.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Centralized</b>
            <span>
              {" "}
              - A centralized organizational structure is one in which a single
              node or a small number of them are in control of an entire
              network.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`CEX (Centralized Exchange) `}</b>
            <span>
              - type of cryptocurrency exchange that is operated by a company
              that owns it in a centralized manner (middleman is present). It is
              the most common means investors use for their cryptocurrency
              holdings.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Chain Reorganization</b>
            <span>
              {" "}
              - process in blockchain technology that allows node operators to
              replace blocks and adopt new ones, in order to create new, longer
              chains of data.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Chain Split `}</b>
            <span>
              - another term used to describe cryptocurrency forks — the
              separation of a single original coin into several independently
              managed projects.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Circulating Supply `}</b>
            <span>
              - The number of coins that are circulating in the market to the
              general public.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Coin `}</b>
            <span>
              - Refers to a cryptocurrency that can operate independently or to
              a single unit of a cryptocurrency
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Coin Mixer</b>
            <span>
              {" "}
              - Allows users to mix up transactions between different
              cryptocurrency addresses, so they become untraceable and cannot be
              followed back to the initial sender or receiver of the assets
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Coinbase `}</b>
            <span>
              - Widely known as the popular crypto exchange, but can also refer
              to the number of coins that are generated from scratch and awarded
              to miners for mining every new block.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Coinbureau `}</b>
            <span>
              - One of the best youtube content creators that offers information
              about cryptocurrency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Contract Address</b>
            <span>
              {" "}
              - It is the address of an Ethereum Contract calculated from the
              address of its creator (sender) and how many transactions the
              creator has sent (nonce) The address location of the actual token
              contract that manages the logic for the tokens on the Ethereum
              Blockchain
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cold Storage</b>
            <span>
              {" "}
              - Offline storage of cryptocurrencies, typically involving
              hardware non-custodial wallets, USBs, offline computers, or paper
              wallets.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Cold Wallet `}</b>
            <span>
              - A cryptocurrency wallet that is in cold storage which is not
              connected to the internet.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Collateral Tokens</b>
            <span>
              {" "}
              - used as a risk mitigation asset when borrowing other types of
              crypto tokens.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Collateralized Stablecoin</b>
            <span>
              {" "}
              - a stablecoin that is entirely or almost entirely backed by
              collateral held in a reserve.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Confirmation</b>
            <span>
              {" "}
              - a measure of how many blocks have passed since a transaction was
              added to a blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Consensus</b>
            <span>
              {" "}
              - refers to when all participants of the network agree on the
              order and content of the blocks in the blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Consensus Mechanism</b>
            <span>
              {" "}
              - the underlying technology behind the main functionalities of all
              blockchain technology, which makes them an essential operating
              feature of all cryptocurrencies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Contract</b>
            <span> - smart contracts execute functions on the blockchain.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Contract Account `}</b>
            <span>
              - account that has a crypto balance and associated code.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>CFD (Contract for Difference)</b>
            <span>
              {" "}
              - contract that outlines a buyer’s obligation to pay any price
              difference that could occur due to the shifting valuation of an
              asset
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Coordinator</b>
            <span>
              {" "}
              - a specialized client that allows nodes to verify the validity of
              their copy of the ledger against specific transactions.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Correction</b>
            <span>
              {" "}
              - pullback of an asset’s price of at least 10% to adjust for
              over-valuation.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cost Basis</b>
            <span>
              {" "}
              - total cost to acquire your crypto asset, including any
              transaction fees**.**
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cross-Chain</b>
            <span>
              {" "}
              - a technology that enhances the interconnection between
              blockchain networks by allowing the exchange of information and
              value.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cross-Chain Communication</b>
            <span>
              {" "}
              - allows different protocols to verify data and transactions
              without the intervention of a centralized third-party service.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cryptoasset</b>
            <span>
              {" "}
              - any digital asset that uses cryptographic technologies to
              maintain its operation as a currency or decentralized application
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cryptocurrency</b>
            <span>
              {" "}
              - digital currencies that use cryptographic technologies to secure
              their operation.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cryptography</b>
            <span>
              {" "}
              - field of study and practice to secure information, preventing
              third parties from reading information to which they are not
              privy.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Cryptology</b>
            <span>
              {" "}
              - the scientific study of cryptography as well as cryptanalysis.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Currency Debasement</b>
            <span>
              {" "}
              - the practice of lowering the intrinsic value of coins,
              especially when used in connection with commodity money, such as
              gold or silver coins.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-4@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Dapps</b>
            <span>
              {" "}
              - Dapps are Decentralised applications. Decentralised applications
              (dApps) are digital applications or programs that exist and run on
              a blockchain or P2P network of computers instead of a single
              computer, and are outside the purview and control of a single
              authority. For example, a developer can create a Twitter-like dApp
              and put it on a blockchain where any user can publish messages.
              Once posted, no one—including the app creators—can delete the
              messages.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dark Web</b>
            <span>
              {" "}
              - A portion of the internet existing on darknets not indexed by
              search engines, that can only be accessed with specific software,
              configurations or authorizations.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Date of Launch</b>
            <span>
              {" "}
              - A term used for when ICOs will put up their tokens for sale.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Day Trading</b>
            <span>
              {" "}
              - the practice of frequently buying and selling assets in order to
              make a profit on intraday changes in their price.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dead Cat Bounce</b>
            <span>
              {" "}
              - temporary recovery in prices after an extensive decrease.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dead Coin</b>
            <span> - cryptocurrency that is no longer in existence.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Death Cross `}</b>
            <span>
              - a bearish technical trading indicator that occurs when the
              50-day moving average falls below the 200-day moving average,
              indicating a big sell-off.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized</b>
            <span>
              {" "}
              - refers to the transfer of control and decision-making from a
              centralized entity (individual, organization, or group thereof) to
              a distributed network.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Applications (DApps)</b>
            <span>
              {" "}
              - type of application that runs on a decentralized network,
              avoiding a single point of failure.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Autonomous Initial Coin Offerings (DAICO)</b>
            <span>
              {" "}
              - method for decentralized funding of projects that introduces a
              form of governance in the ICO process, allowing backers to vote
              for the return of their funds if certain conditions are met.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Autonomous Organizations (DAO)</b>
            <span>
              {" "}
              - is founded upon and governed by a set of computer-defined rules
              and blockchain-based smart contracts.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Currency</b>
            <span>
              {" "}
              - refers to bank-free methods of transferring wealth or ownership
              of any other commodity without needing a third party.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Database</b>
            <span>
              {" "}
              - a modern-day storage solution that combines decentralized
              technologies with cutting-edge computing to randomly store data
              and files across multiple nodes, delivering high security and
              unmatched availability while being completely
              censorship-resistant.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Decentralized Exchange (DEX) `}</b>
            <span>
              - peer-to-peer exchange allowing users to trade cryptocurrency
              without the need for an intermediary.
            </span>
          </p>
          <p className="m-0">
            Decentralized Governance - refers to the procedures through which a
            platform's disintermediated, equitable management is carried out for
            blockchain networks and dApps.
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Identifier (DID)</b>
            <span>
              {" "}
              - refers to an ID that can be issued by an autonomous,
              independent, and decentralized platform that acts as a proof of
              ownership of digital identity.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Decentralized Marketplace `}</b>
            <span>
              - built on blockchain technology, allows traders or investors to
              trade with each other while eliminating middlemen. They are
              available globally and require no intermediaries to make trades
              possible.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Network</b>
            <span>
              {" "}
              - a collection of interconnected but distinct elements that
              interact with one another without the need for a centralized power
              or server.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Payment Network</b>
            <span>
              {" "}
              - a system where users, customers and vendors can exchange money
              without having to trust any third party to keep the network secure
              and operational.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Decentralized Stablecoin</b>
            <span>
              {" "}
              - stablecoins that are fully transparent, non-custodial with no or
              partial third-party control.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Decryption `}</b>
            <span>
              - The process of transforming encrypted data back into a format
              that is readable by a user or machine.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Deep Web `}</b>
            <span>
              - referred to as the part of the internet that is hidden from
              regular search engines.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>DeFi (Decentralized Finance)</b>
            <span>
              {" "}
              - movement encouraging alternatives to traditional, centralized
              forms of financial services.
            </span>
          </p>
          <p className="m-0">
            <b className="font-dm-sans">{`DeFi Aggregator `}</b>
            <span>
              - brings together trades across various DeFi platforms into one
              place.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`DeFi Degens `}</b>
            <span>
              - subculture associated with a disreputable corner of
              decentralized finance known for their pump and dump schemes.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Deflation</b>
            <span>
              {" "}
              - A decline in the general level of prices for goods and services
              in an economy.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Delegated Proof-of-Stake (dPOS)</b>
            <span>
              {" "}
              - alternative to the Proof-of-Stake and Proof-of-Work consensus
              algorithms.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Delta Neutral</b>
            <span>
              {" "}
              - a portfolio strategy utilizing multiple positions with balancing
              positive and negative deltas so that the overall delta of the
              assets in question totals zero.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Delisting `}</b>
            <span>
              - process of removing an asset/stock/cryptocurrency from a trading
              exchange is called delisting.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Depth Chart</b>
            <span>
              {" "}
              - A graph that plots the requests to buy (bids) and the requests
              to sell (asks) on a chart, based on limit orders. The chart shows
              the point at which the market is most likely to accept a
              transaction.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Derivative</b>
            <span>
              {" "}
              - financial instrument deriving its value from the value of an
              underlying asset.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Deterministic Wallet</b>
            <span>
              {" "}
              - type of cryptocurrency wallet in which keys and addresses are
              created from a single seed.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dex</b>
            <span>
              {" "}
              - Dexs are Decentralised exchanges. Decentralised exchanges are a
              type of cryptocurrency exchange which allows for direct
              peer-to-peer cryptocurrency transactions to take place online
              securely and without the need for an intermediary.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Dex Aggregator `}</b>
            <span>
              - are a relatively new type of blockchain-based service that
              allows cryptocurrency traders to benefit from a large variety of
              financial tools in a single interface, often providing better
              liquidity and prices on different crypto pairs.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Diamond Hands</b>
            <span>
              {" "}
              - is a popular term on social media platforms. It refers to people
              who hold their coins even if their portfolio drops in value by
              more than 20%.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Digital Signature</b>
            <span>
              {" "}
              - method for proving the authenticity of a digital communication.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dildo</b>
            <span>
              {" "}
              - a green/red candle that appears in a lot of graphs which tells
              you about the increase or decrease of the exchange price of a
              certain token.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dip</b>
            <span>
              {" "}
              - when markets experience a short or protracted downturn.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Directed Acyclic Graph (DAG)</b>
            <span>
              {" "}
              - A way of structuring data, often used for data modelling, and
              increasingly as a consensus tool in cryptocurrencies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Distributed Consensus `}</b>
            <span>
              - Collective agreement reached among nodes in a network.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Distributed Denial-of-Service (DDoS)</b>
            <span>
              {" "}
              - a method where cyber criminals flood a computer or network with
              so much malicious traffic that it cannot operate or communicate as
              it normally would for its intended users.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Distributed Ledger</b>
            <span>
              {" "}
              - are ledgers in which data is stored across a network of
              decentralized nodes. A distributed ledger does not necessarily
              involve a cryptocurrency and may be permissioned and private.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Distributed Ledger Technology (DLT) `}</b>
            <span>
              - database that is shared by multiple participants, in multiple
              places. The basis for blockchains.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Distributed Network</b>
            <span>
              {" "}
              - network in which the data and applications are dependent on
              multiple sources, as opposed to one location.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Diversification</b>
            <span>
              {" "}
              - an important risk-management strategy that mixes a wide variety
              of investments within a portfolio in an effort to minimize risk.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Documentation `}</b>
            <span>
              - a part of token economies that stores all the details of an
              asset on the blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dollar-Cost Averaging (DCA)</b>
            <span>
              {" "}
              - an investing technique that helps to invest a certain amount of
              money in small increments at regularly scheduled intervals. The
              strategy uses changes in the market price over long periods.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Dolphin `}</b>
            <span>- Someone with a moderate holding of cryptocurrency.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Dopamine `}</b>
            <span>
              - is a type of neurotransmitter. Your body makes it, and your
              nervous system uses it to send messages between nerve cells. It's
              closely associated with pleasurable sensations.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>DotSama</b>
            <span>
              {" "}
              - crypto slang used to describe the Kusama and Polkadot ecosystems
              in one word.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Double Spend Attack `}</b>
            <span>
              - where a user gains the ability to spend the same cryptocurrency
              more than once.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dual-Token Economy/Model (Two-Token Economy)</b>
            <span>
              {" "}
              - means a project with two tokens, one of which is used for
              utility inside the network and the other one as security to raise
              funds for the crypto project.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dump</b>
            <span> - sudden sell-off of digital assets.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dumping</b>
            <span>
              {" "}
              - collective market sell-off that occurs when large quantities of
              a particular cryptocurrency are sold in a short period of time.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dust Transactions</b>
            <span>
              {" "}
              - very small amounts of Bitcoin in a wallet — with a value that
              would be outweighed by the cost of a transaction fee.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dusting Attack</b>
            <span>
              {" "}
              - An attack that aims to reveal the identity of a wallet’s owner,
              information that can subsequently be used in phishing scams.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Dynamic Coin Offering (DYCO)</b>
            <span>
              {" "}
              - is a new crowdfunding model developed by DAO Maker that employs
              utility tokens that are backed by USD.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Do Your Own Research (DYOR)</b>
            <span>
              {" "}
              - an important acronym encouraging all crypto investors to
              complete their due diligence research into any project before
              investing.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-5@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`E-Signature `}</b>
            <span>
              - is any electronic mark (sign, sound, symbol, etc.) used in the
              palace of a physical signature in signing a document or contract.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>ELI5</b>
            <span>
              {" "}
              - Short for “explain like I’m five” -a plea for simplicity when
              crypto concepts are being explained.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Elliott Waves</b>
            <span>
              {" "}
              - a theory in technical analysis used to describe price movements
              in the crypto market
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>EMA (Exponential Moving Average)</b>
            <span>
              {" "}
              - is a technical indicator that highlights the recent price
              changes and data points of an asset/stock/
            </span>
          </p>
          <p className="m-0">
            cryptocurrency while keeping the older chart observations intact.
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Emission</b>
            <span>
              {" "}
              - The speed at which new coins are produced and released.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Encryption</b>
            <span>
              {" "}
              - a method through which information can be made into code.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`EEA (Enterprise Ethereum Alliance) `}</b>
            <span>
              - A group of organizations and companies working together to
              further develop the Ethereum network.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>ERC-1155</b>
            <span>
              {" "}
              - digital token standard was created by Enjin and offers more
              security in comparison to older token standards. It can be used to
              create both fungible and non-fungible assets on the Ethereum
              network.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`ERC-20 `}</b>
            <span>
              - Tokens designed and used solely on the Ethereum platform.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>ERC-223</b>
            <span>
              {" "}
              - an Ethereum token standard that is powered by smart contracts
              that enable users to securely transfer tokens to a digital wallet.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>ERC-721</b>
            <span> - A token standard for non-fungible Ethereum tokens.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>ERC-777</b>
            <span>
              {" "}
              - a tradable token standard spun out from ERC-20 to enable a new
              way to engage with a token contract while staying backward
              compatible.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>ERC-884</b>
            <span>
              {" "}
              - facilitates the creation of tradable ERC-20 tokens, each of
              which symbolizes a numberless share issued by a Delaware
              corporation.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>ERC-948</b>
            <span>
              {" "}
              - a new Ethereum token protocol that is designed to connect
              subscription businesses with customers and allows for
              subscription-based transactions.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Escrow</b>
            <span>
              {" "}
              - A financial instrument where assets or cash are held by a third
              party while a buyer and a seller complete a deal.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Ethash</b>
            <span>
              {" "}
              - the algorithm utilized for the proof of work mining Ethereum and
              ETH-based cryptocurrencies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Ether `}</b>
            <span>
              - The form of payment used in the operation of the distribution
              application platform, Ethereum.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`EIP (Ethereum Improvement Proposal) `}</b>
            <span>
              - describe standards for the Ethereum platform, including core
              protocol specifications, client APIs, and contract standards.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Ethereum Transaction `}</b>
            <span>
              - are cryptographically signed instructions to initiate a
              transaction to update the state of the Ethereum network.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>EVM (Ethereum Virtual Machine)</b>
            <span>
              {" "}
              - A Turing-complete virtual machine that enables execution of code
              exactly as intended; it is the runtime environment for every smart
              contract. Every Ethereum node runs on the EVM to maintain
              consensus across the blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Exchange</b>
            <span>
              {" "}
              - Organizations that allow customers to trade cryptocurrencies for
              fiat money or other cryptocurrencies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Exit Scam</b>
            <span>
              {" "}
              - is a scam where projects disappear (or shut down) after
              accumulating investors’ money. In other industries, this event
              occurs when a business stops shipping orders even if it is
              receiving payment for the new ones. This is very common in NFTs.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-6@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Falling Knife</b>
            <span>
              {" "}
              - refers to the price dive of an asset and denotes a downward
              momentum of the financial market
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fan Token</b>
            <span>{` - is a cryptocurrency issued by a specific sports team and allows its holders to participate in the governing activities and attain exclusive rewards & discounts.`}</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>FATF Travel Rule</b>
            <span>
              {" "}
              - requires virtual asset service providers to regulate information
              sharing for certain large transactions.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Faucet</b>
            <span>
              {" "}
              - A cryptocurrency reward system usually on a website or app, that
              rewards users for completing certain tasks.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Fee Tiers `}</b>
            <span>
              - refer to the fee structure that determines the amount charged
              when investors deposit or withdraw money and execute trades on a
              crypto exchange.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>FCFS</b>
            <span>
              {" "}
              - First Come First Serve. Be as quick as possible before it sells
              out.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <span>F</span>
            <b className="font-dm-sans">ees</b>
            <span>
              {" "}
              - Fees refer to additional costs you will encounter when
              transfering your asset on a blockchain. These are also known as
              Transaction Fees, such as Gas Fees.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fiat</b>
            <span>
              {" "}
              - is “legal tender” backed by a central government, such as the
              Federal Reserve, and with its own banking system, such as
              fractional reserve banking. It can take the form of physical cash,
              or it can be represented electronically, such as with bank credit.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fiat On-Ramp</b>
            <span>
              {" "}
              - is a way to get cryptocurrency from fiat, or regular money.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fiat-Pegged Cryptocurrency</b>
            <span>
              {" "}
              - A coin, token or asset issued on a blockchain that is linked to
              a government or bank-issued currency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fibonacci Retracement Level</b>
            <span>
              {" "}
              - The Fibonacci retracement method uses a set of key numbers
              called Fibonacci ratios to identify the support and resistance
              levels of an asset/stock/cryptocurrency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Financial Action Task Force (FATF)</b>
            <span>
              {" "}
              - is a global organization that sets global standards to combat
              money laundering and terrorist financing (AML/CFT).
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Financial Crime Enforcement Network (FinCEN) `}</b>
            <span>
              - is a federal regulatory bureau of the United States Treasury.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Financial Transactions and Reports Analysis Centre (FINTRAC)</b>
            <span className="font-dm-sans">
              {" "}
              - of Canada is the nation’s financial intelligence agency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>First In, First Out (FIFO)</b>
            <span>
              {" "}
              - is an inventory method used to specify your cost-basis when
              calculating your taxes.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>First-Mover Advantage (FMA)</b>
            <span>
              {" "}
              - refers to the launch of an innovative product or service which
              provides a head-start to a company by creating brand loyalty and
              penetrating markets before their future competitors.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fish</b>
            <span> - Someone who has a small crypto investment.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Flash Crash `}</b>
            <span>
              - is a market condition where an asset’s price falls very rapidly
              within a very brief time interval.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Flash Loan</b>
            <span>
              {" "}
              - is a transaction in which a specific quantity of liquidity is
              borrowed and repaid in the same transaction or block.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Flash Loan Attack</b>
            <span> - when malicious actors exploit a smart contract.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Flash Loans `}</b>
            <span>
              - a type of uncollateralized lending used in decentralized finance
              (DeFi).
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Flippening</b>
            <span>
              {" "}
              - A hypothetical scenario where Ethereum's market cap overtakes
              Bitcoin's.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Flipping</b>
            <span>
              {" "}
              - An investment strategy where you buy something with the goal of
              reselling for a profit later, usually in a short period of time.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>FOMO</b>
            <span> - An acronym that stands for "Fear of Missing Out."</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Fork (Blockchain) `}</b>
            <span>
              - Forks, or chain splits, create an alternate version of the
              blockchain, leaving two blockchains to run simultaneously.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Fork (Software) `}</b>
            <span>
              - When an entirely new program has been developed from source
              code, taken from an open-source software.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fractional Stablecoins</b>
            <span>
              {" "}
              - is backed in two ways: collaterally-backed and algorithmically
              modified.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Fraud Proof `}</b>
            <span>
              - is a technological method that functions as a bond in a
              decentralized environment that uses Optimistic Rollups (ORs),
              which are sidechains that aim to reduce the costs and latency that
              dApps might encounter on a blockchain platform.
            </span>
          </p>
          <p className="m-0">
            Front Running - is when you place a transaction in a queue when you
            have knowledge of a future transaction.
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>FUD</b>
            <span>
              {" "}
              - stands for “Fear, Uncertainty and Doubt.” It is a strategy to
              influence the perception of certain cryptocurrencies or the
              cryptocurrency market in general by spreading negative,
              misleading, or false information.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`FUDster `}</b>
            <span>- Someone that is spreading FUD.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Full Node</b>
            <span>
              {" "}
              - Nodes that download a blockchain’s entire history in order to
              observe and enforce its rules.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Fundamental Analysis (FA) `}</b>
            <span>
              - A method in which you research the underlying value of an asset
              by looking at the technology, team, growth prospects and other
              indicators. Some people perform fundamental analysis as part of an
              investment strategy called “value investing.”
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Funding Payments</b>
            <span>
              {" "}
              - periodic payments between traders. These are designed to reduce
              the discrepancy between the perpetual market price and the spot
              market price.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Fungible</b>
            <span>
              {" "}
              - In cryptocurrency, fungibility is when a coin or token can be
              replaced by any other identical coin or token.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Futures</b>
            <span>
              {" "}
              - is a standardized legal agreement to buy or sell a particular
              commodity or asset at a predetermined price at a specified time in
              the future.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-7@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Gains</b>
            <span> - refer to an increase in value or profit.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Game Channels</b>
            <span>
              {" "}
              - are the newest technological advancement in the world of
              blockchain gaming, as they enable fast gameplay by removing the
              wait time for block confirmations. With game channels, games and
              dApps can run off-chain securely, individually, and in near
              real-time.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>GameFi</b>
            <span>
              {" "}
              - better known as play-to-earn (P2E) games, is a rather new term
              in the field of both gaming and cryptocurrency industries. It
              references games that are designed with economic and financial
              aspects of blockchain and cryptocurrencies, enabling players to
              exert full control over their in-game assets to generate revenue.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Gas</b>
            <span>
              {" "}
              - A term used on the Ethereum platform that refers to a unit of
              measuring the computational effort of conducting transactions or
              smart contracts, or launch DApps in the Ethereum network. It is
              the “fuel” of the Ethereum network. *see Gas Limit and Gas Price.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Gas Limit `}</b>
            <span>
              - A term used on the Ethereum platform that refers to the maximum
              amount of gas the user is willing to spend on a transaction.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Gas Price</b>
            <span>
              {" "}
              - A term used on the Ethereum platform that refers to the price
              you are willing to pay for a transaction.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Gavin Wood</b>
            <span>
              {" "}
              - is the co-founder of Parity Technologies, and one of the
              founders of Ethereum.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Gems</b>
            <span>
              {" "}
              - is a term for relatively unknown low-cap coins that have immense
              potential or are grossly undervalued.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Genesis Block</b>
            <span>
              {" "}
              - The first block of data that is processed and validated to form
              a new blockchain, often referred to as block 0 or block 1.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Geth `}</b>
            <span>
              - short for Go Ethereum, is a command-line interface that allows
              developers to run full Ethereum nodes, mine the cryptocurrency and
              execute smart contracts.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>GitHub</b>
            <span>
              {" "}
              - one of the most popular code hosting platforms, allowing
              developers to collaborate on various projects.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Golden Cross</b>
            <span>
              {" "}
              - is a bullish technical trading indicator that emerges when the
              50-day moving average crosses the 200-day moving average,
              signaling an imminent price rise of the
              asset/stock/cryptocurrency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Governance `}</b>
            <span>
              - is defined as the people or organizations that have
              decision-making powers regarding the project.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Governance Token `}</b>
            <span>
              - is a token that can be used to vote on decisions that influence
              an ecosystem.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Graphical Processing Unit (GPU)</b>
            <span>
              {" "}
              - More commonly known as a graphics card, it is a computer chip
              that creates 3D images on computers, and is efficient for mining
              cryptocurrencies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`GWEI `}</b>
            <span>
              - short for gigawei, or 1,000,000,000 wei. Wei, as the smallest
              (base) unit of ether. It's the denomination used in defining the
              cost of gas in transactions involving Ether.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-8@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Hal Finney `}</b>
            <span>
              - a cryptographer and programmer who pioneered Bitcoin’s
              development and worked with the infamous Satoshi Nakamoto.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hard Cap</b>
            <span> - is the absolute maximum supply of a digital asset.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hard Fork (Blockchain)</b>
            <span>
              {" "}
              - A type of protocol change that validates all previously invalid
              transactions, and invalidates all previously valid transactions.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hardware Security Module</b>
            <span>
              {" "}
              - is a type of computing device that secures digital keys and
              encrypts data.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hardware Wallet</b>
            <span>
              {" "}
              - is a wallet for cryptocurrencies that usually resemble a USB
              stick.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Hash `}</b>
            <span>
              - is the output result of a hashing algorithm, which creates a
              unique, fixed-length string to encrypt and secure a certain
              selection of arbitrary data.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hash Power / Hash Rate</b>
            <span>
              {" "}
              - A unit of measurement for the amount of computing power being
              consumed by the network to continuously operate.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hidden Cap</b>
            <span>
              {" "}
              - is an unknown limit to the amount of money a team elects to
              receive from investors in its initial coin offering (ICO). The
              purpose of a hidden cap is to even the playing field by letting
              smaller investors put in money, without the large investors
              forming an accurate understanding of the total cap and adjusting
              their investment as a result.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hold On for Dear Life (HODL)</b>
            <span>
              {" "}
              - A type of passive investment strategy where you hold an
              investment for a long period of time, regardless of any changes in
              the price or markets. The term first became famous due to a typo
              made in a Bitcoin forum.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Honeyminer `}</b>
            <span>
              - is a cryptocurrency mining app available for download on
              multiple devices.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hosted Wallet</b>
            <span> - a wallet managed by a third-party service.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Hot Storage `}</b>
            <span>
              - The online storage of private keys allowing for quicker access
              to cryptocurrencies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hot Wallet</b>
            <span>
              {" "}
              - A cryptocurrency wallet that is connected to the internet for
              hot storage of crypto assets, as opposed to an offline, cold
              wallet with cold storage.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Hybrid PoW/PoS `}</b>
            <span>
              - allows for both proof-of-stake and proof-of-work as consensus
              distribution algorithms on the network. This approach aims to
              bring together the security of PoW consensus and the governance
              and energy efficiency of PoS.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Hyperledger (Hyperledger Foundation)</b>
            <span>
              {" "}
              - an umbrella project of open-source blockchains and
              blockchain-related tools started by the Linux Foundation in 2015
              to support the collaborative development of blockchain-based
              distributed ledgers.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-9@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Impermanent Loss</b>
            <span>
              {" "}
              - when a liquidity provider has a temporary loss of funds because
              of volatility in a trading pair.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Immutable</b>
            <span> - Unchanging over time or unable to be changed.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Infinite Approval</b>
            <span>
              {" "}
              - pre-approving smart contracts to enable the platform to spend
              any amount of your coins.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Inflation</b>
            <span>
              {" "}
              - a general increase in prices and fall in the purchasing value of
              money.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Initial Bounty Offering (IBO) `}</b>
            <span>
              - way of launching a project that focuses on people contributing
              skills to a platform rather than money.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Initial Coin Offering (ICO)</b>
            <span>
              {" "}
              - a type of crowdfunding using cryptocurrencies as a means of
              raising capital for early-stage companies.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Initial Dex Offering (IDO)</b>
            <span>
              {" "}
              - a fundraising approach that pools investment capital from retail
              investors.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>IEOs (Initial Exchange Offerings)</b>
            <span>
              {" "}
              - Similar to ICOs these initial offerings of digital assets (e.g.,
              coins or tokens) are to raise capital. However, they are offered
              directly by online trading platforms on behalf of companies for a
              fee.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Initial Farm Offering (IFO)</b>
            <span>
              {" "}
              - helps DeFi projects raise capital through the farming feature
              offered by decentralized exchanges.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Initial Public Offering (IPO) `}</b>
            <span>
              - is the process of a company offering shares for purchase on the
              stock market for the first time.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Initial Token Offering (ITO)</b>
            <span>
              {" "}
              - focus on offering tokens with intrinsic utility in the form of
              software or usage in an ecosystem.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Instamine</b>
            <span>
              {" "}
              - when a large portion of a coin’s total supply is distributed to
              investors shortly after launch.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Instant Settlement Network Layer `}</b>
            <span>
              - allows participants to exchange digital assets in real-time from
              anywhere in the world.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Intermediary `}</b>
            <span>
              - a person or entity that acts as the go-between different parties
              to bring about agreements or carry out directives.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Internal Transaction</b>
            <span>
              {" "}
              - also known as a "message," is a byproduct of an EOA interaction
              with a contract address that results in Ether being transferred.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Interoperability `}</b>
            <span>
              - Blockchain interoperability, or cross-chain interoperability, is
              the ability to see and share information across multiple
              blockchains.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>InterPlanetary File System (IPFS)</b>
            <span>
              {" "}
              - a peer-to-peer, distributed system for storing and accessing
              files, as well as websites and applications, which relies on
              content addressing rather than location.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Intrinsic Value `}</b>
            <span>
              - depicts an asset’s actual worth based on a complex financial
              calculation rather than its current price.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-10@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <b>{`Joy Of Missing Out (JOMO) `}</b>
          <span>- opposite mental state of FOMO</span>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-11@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Keylogger `}</b>
            <span>
              - spying software tool often used by hackers to record keystrokes
              made by users.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Kimchi Premium</b>
            <span>
              {" "}
              - the gaps in cryptocurrency prices in South Korean exchanges
              compared to other exchanges located globally.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Know Your Customer (KYC) `}</b>
            <span>
              - the process of verifying your customer's identity. (Becoming
              more common with certain cryptocurrency exchanges)
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-12@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Lambo</b>
            <span>
              {" "}
              - slang for the type of car that many crypto enthusiasts aspire to
              buy when their digital assets “moon” (rise in value
              substantially).
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Large Cap `}</b>
            <span>
              - Well-established projects and organizations having a market
              capitalization of $10 billion or above are called large cap or big
              cap projects/organizations.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Laser Eyes</b>
            <span>
              {" "}
              - a viral Twitter meme that was used by Bitcoiners who attempt to
              push the price of BTC to its new all-time highs. It was originated
              with a hashtag, #LaserRayUntil100, back in February 2021.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Layer 0</b>
            <span>
              {" "}
              - is a network framework running beneath the blockchain. It is
              made up of protocols, connections, hardware, miners, and
              everything else that forms the foundation of the blockchain
              ecosystem.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Layer 1 Blockchain</b>
            <span>
              {" "}
              - is a set of solutions that improve the base protocol itself
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Layer 2</b>
            <span>
              {" "}
              - is the name given to a scaling solution that enables high
              throughput of transactions whilst fully inheriting the security of
              the underlying blockchain that it is built on.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Ledger `}</b>
            <span>
              - a record of financial transactions that cannot be changed, only
              appended with new transactions.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Leverage `}</b>
            <span>
              - money that a trader borrows from a brokerage, enabling them to
              gain greater exposure to a position than what their capital budget
              actually allows.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Leveraged Tokens</b>
            <span>
              {" "}
              - give you a leveraged position in trading, meaning that your
              earnings and losses are multiplied.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Light Node `}</b>
            <span>
              - downloaded wallets that are connected to full nodes to further
              validate the information that is stored on the blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Lightning Network</b>
            <span>
              {" "}
              - a second-layer protocol that is designed to solve Bitcoin’s
              scalability problem by allowing transactions to be processed more
              quickly.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Limit Order</b>
            <span>
              {" "}
              - a limit order is a type of order to purchase or sell a security
              at a specified price or a better one.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Limit Order/Limit Buy/Limit Sell</b>
            <span>
              {" "}
              - tools that enable traders to automatically buy or sell
              cryptocurrencies on a trading platform when a certain price target
              is reached.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Liquid Market `}</b>
            <span>
              - refers to a market with large number of buyers and sellers. It
              is a platform where all the trades are executed with ease and at a
              low cost.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Liquidation</b>
            <span>
              {" "}
              - refers to the conversion of an asset or cryptocurrency for fiat
              or its equivalents.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Liquidity</b>
            <span>
              {" "}
              - how easily a cryptocurrency can be bought and sold without
              impacting the overall market price.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Liquidity Bootstrapping Pool (LBP)</b>
            <span>
              {" "}
              - a contract that manages a core pool containing tokens to be used
              on an exchange.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Liquidity Mining</b>
            <span>
              {" "}
              - is a mechanism or process in which participants supply
              cryptocurrencies into liquidity pools, and are rewarded with fees
              and tokens based on their share of the total pool liquidity.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Liquidity Pool `}</b>
            <span>
              - are crypto assets that are kept to facilitate the trading of
              trading pairs on decentralized exchanges.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Liquidity Provider</b>
            <span>
              {" "}
              - are decentralized exchange users who fund a liquidity pool with
              tokens they own.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Liquidity Provider Tokens (LP Tokens)</b>
            <span>
              {" "}
              - tokens issued to liquidity providers on a decentralized exchange
              (DEX) that run on an automated market maker (AMM) protocol.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Long</b>
            <span>
              {" "}
              - when a trader buys a cryptocurrency with the expectation of
              selling it at a higher price for profit later.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Longing (Long Position)</b>
            <span>
              {" "}
              - refers to the situation where an investor buys a cryptocurrency
              or any other financial instrument to sell it later when the price
              goes high.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-13@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Mainnet `}</b>
            <span>
              - an independent blockchain running its own network with its own
              technology and protocol.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Mainnet Swap</b>
            <span>
              {" "}
              - refers to the shift of a cryptocurrency project from one
              blockchain network to another (which in most cases is its own
              native blockchain network).
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Malware</b>
            <span>
              {" "}
              - refers to harmful programs utilized by bad actors to illegally
              access and/or compromise a computer, network or server.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Margin Call `}</b>
            <span>
              - when an investor’s account value falls below the margin
              maintenance amount.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Margin Trading `}</b>
            <span>
              - practice where a trader uses borrowed funds from a broker to
              trade a cryptocurrency.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Market</b>
            <span>
              {" "}
              - an area or arena, online or offline, in which commercial
              dealings are conducted.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Marketplace</b>
            <span>
              {" "}
              - A crypto-marketplace such as Opensea, allows for secondary
              transactions to occur between buyers and sellers through the use
              of Smart Contracts.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">
              Market Capitalization/Market Cap/MCAP
            </b>
            <span>
              {" "}
              - total capitalization of a cryptocurrency’s price. It is one of
              the ways to rank the relative size of a cryptocurrency.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Market Maker/Market Taker `}</b>
            <span>
              - the maker places an order (to buy or sell at a quoted price),
              while a taker accepts that placed order (to execute the buy or
              sell at the quoted price)
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Market Order/Market Buy/Market Sell `}</b>
            <span>
              - a purchase or sale of a cryptocurrency on an exchange at the
              current best available price.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Market Signal</b>
            <span>
              {" "}
              - through signaling, market participants are essentially creating
              a volatile market which can help to point out the opportunities to
              the investors.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Masternodes `}</b>
            <span>
              - are servers maintained by their owner, somewhat like full nodes,
              but with additional functionalities such as anonymizing
              transactions, clearing transactions, and participating in
              governance and voting. It was initially popularized by Dash to
              reward owners of these servers for maintaining a service for the
              blockchain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Max Supply</b>
            <span>
              {" "}
              - the best approximation of the maximum amount of coins that will
              ever exist in the lifetime of the cryptocurrency.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Medium `}</b>
            <span>
              - a good which is used to facilitate the exchange of other goods.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Medium of Exchange</b>
            <span>
              {" "}
              - an intermediary instrument or system that is used to facilitate
              a sale, purchase or even trade of goods between parties.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Megahashes Per Second (MH/s) `}</b>
            <span>
              - a unit of measurement that equals one million hashes per second.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Memecoin `}</b>
            <span>
              - are the crypto tokens created as a joke or meme and claim to
              offer huge gains to holders. (DOGE, SHIBA INU)
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>
              Mempool - is the node's collection of all of the unconfirmed
              transactions that it has seen.
            </b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>MetaMask</b>
            <span>
              {" "}
              - a popular online digital wallet that allows users to manage,
              transfer and receive Ethereum, operating as an extension to a
              regular browser.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Metaverse</b>
            <span>
              {" "}
              - is a digital universe that contains all the aspects of the real
              world, such as real-time interactions and economies. It offers a
              unique experience to end-users.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Micro Cap</b>
            <span>
              {" "}
              - a digital asset with a very small market capitalization is
              referred to as a micro-cap stock/asset/cryptocurrency in the
              financial sector.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`MicroBitcoin (uBTC) `}</b>
            <span>
              - one-millionth of a bitcoin or 0.000001 of a bitcoin. Often
              confused as a fork of Bitcoin.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Mid Cap</b>
            <span>
              {" "}
              - is a measure derived from a mathematical computation that
              determines the market value of a cryptocurrency with a market
              capitalization ranging from $1 billion to $10 billion.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>MilliBitcoin (μBTC)</b>
            <span>
              {" "}
              - is a sub-unit of Bitcoin which is equivalent to the
              one-thousandth of a BTC
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Miner Extractable Value (MEV)</b>
            <span>
              {" "}
              - is a measure of the profit a miner can make through their
              ability to arbitrarily include, exclude, or re-order transactions
              within the blocks they produce.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Miners `}</b>
            <span>
              - contributors to a blockchain taking part in the process of
              mining. They can be professional miners or organizations with
              large-scale operations, or hobbyists who set up mining rigs at
              home or in the office.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Mining `}</b>
            <span>
              - a process where blocks are added to a blockchain, verifying
              transactions. It is also the process through which new bitcoin or
              some altcoins are created.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Mining Contract</b>
            <span>
              {" "}
              - another term for cloud mining, where users can rent or invest in
              mining capacity online.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Mining Difficulty</b>
            <span>
              {" "}
              - is how difficult it is to find the right hash for the next block
              for a specific crypto.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Mining Pool</b>
            <span>
              {" "}
              - a number of miners pool their resources to increase their
              chances of finding the next block.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Mining Reward `}</b>
            <span>
              - the income that miners receive after finding and validating a
              block.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Mnemonic Phrase</b>
            <span>
              {" "}
              - a list of words used in sequence to access or restore your
              crypto assets.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Mobile Wallet</b>
            <span> - a crypto wallet installed on a mobile device.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Monetary Policy</b>
            <span>
              {" "}
              - defined as a set of rules that a country’s central bank makes to
              control the supply of money.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Money Flow Index (MFI) `}</b>
            <span>
              - is a technical indicator that measures the buying or selling
              pressure of an asset through price and volume.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Moon (Mooning) `}</b>
            <span>
              - slang for a situation where there is a continuous upward
              movement in the price of a cryptocurrency.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Moving Average (MA)</b>
            <span>
              {" "}
              - is a technical indicator that reacts to the trends of the
              financial markets and is used by market experts to predict the
              direction of an asset's trend.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Multi-Coin Wallet</b>
            <span>
              {" "}
              - also known as a multi-chain wallet, allows users to keep more
              than one crypto asset belonging to multiple blockchain networks.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Multi-Party Computation (MPC) `}</b>
            <span>
              - is a cryptographic mechanism that distributes computation
              operations across several parties where no singular entity can see
              the other parties’ data.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Multi-Signature (Multi-Sig)</b>
            <span>
              {" "}
              - an added layer of security by requiring more than one key to
              authorize a transaction.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Multisignature `}</b>
            <span>
              - crypto wallets require more than a single signature to sign a
              transaction.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-14@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Negative Volume Index (NVI)</b>
            <span>
              {" "}
              - a powerful technical indicator that shows how price is being
              influenced by low-volume timeframes.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Network `}</b>
            <span>
              - refers to all nodes in the operation of a blockchain at any
              given moment in time.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Noob</b>
            <span> - is someone that is new to a certain industry.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Nifty Gateway</b>
            <span> - is an NFT platform owned by the Winklevoss twins.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">No-Coiner</b>
            <span>
              {" "}
              - is someone who has no cryptocurrency in his or her investment
              portfolio and firmly believes that cryptocurrency will fail.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Node</b>
            <span>
              {" "}
              - the most basic unit of blockchain infrastructure that stores
              data
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Non-Custodial</b>
            <span>
              {" "}
              - usually referring to the storage of keys, in relation to wallets
              or exchanges, a non-custodial setup is one in which private keys
              are held by the user directly.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Non-Fungible Token (NFT)</b>
            <span>
              {" "}
              - is a unique and non-interchangeable unit of data stored on a
              digital ledger.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Nonce `}</b>
            <span>
              - when a transaction is hashed by a miner, this arbitrary number
              meant to be used only once is generated.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-15@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Off-Chain</b>
            <span>
              {" "}
              - a transaction that is processed outside the blockchain network
              with an increased speed and reduced cost.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Off-Chain Governance `}</b>
            <span>
              - a type of blockchain governance in which decisions are made
              informally, away from the primary code base of the blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Off-Chain Transaction</b>
            <span>
              {" "}
              - is defined as a second-layer protocol where the transactions
              occur on a network and move value outside of the blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Off-Ledger Currency</b>
            <span>
              {" "}
              - a currency that is created (minted) outside of the specified
              blockchain ledger but is accepted or used.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Offline Storage (Cold Storage) `}</b>
            <span>
              - the act of storing cryptocurrencies in devices or systems not
              connected to the internet.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`On-Balance Volume (OBV) `}</b>
            <span>
              - is a technical trading indicator that forecasts an asset's price
              movements based on the volume flow.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">On-Chain</b>
            <span>
              {" "}
              - transactions that are recorded on the blockchain itself and
              shared with all of the participants are done on-chain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">On-Chain Governance</b>
            <span>
              {" "}
              - is a decentralized framework used for organizing and integrating
              updates/improvements to the blockchain networks.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`On-Ledger Currency `}</b>
            <span>
              - a currency that is both minted on the blockchain ledger and also
              used on the blockchain ledger (BTC).
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`One Cancels the Other Order (OCO) `}</b>
            <span>
              - a situation where two orders for cryptocurrency are placed
              simultaneously, with a rule in place to enforce that if one is
              accepted, the other is canceled.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Online Storage (Hot Storage) `}</b>
            <span>
              - the act of storing cryptocurrencies in devices or systems
              connected to the internet.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Open Source</b>
            <span>
              {" "}
              - is a philosophy, with participants believing in the free and
              open sharing of information in pursuit of the greater common good.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Open/Close</b>
            <span>
              {" "}
              - the price at which a cryptocurrency opens at a time period or
              the programming principle of software parts being extendable.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>OpenSea</b>
            <span> - is a popular decentralized P2P platform for NFTs.</span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Option</b>
            <span>
              {" "}
              - a contract giving the buyer the right, but not the obligation,
              to buy or sell an underlying asset or instrument at a specified
              strike price.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Options Market</b>
            <span>
              {" "}
              - a public market for options, giving the buyer an option to buy
              or sell a cryptocurrency at a specific strike price, on or before
              a specific date.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Oracles</b>
            <span>
              {" "}
              - an agent that finds and verifies information, bridging the real
              world and the blockchain by providing data to smart contracts for
              execution of said contracts under specified conditions.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Order Book `}</b>
            <span>
              - a list of orders that shows various offers from buyers and
              sellers for a specific security.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Orphaned Block `}</b>
            <span>
              - is a block where the parent block does not exist or is unknown.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Over-the-Counter (OTC) `}</b>
            <span>
              - is defined as a transaction made outside of an exchange, often
              peer-to-peer through private trades.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Over-the-Counter (OTC) Trading</b>
            <span>
              {" "}
              - refers to the process of how securities are traded through a
              broker-dealer network as opposed to a centralized exchange.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Overbought</b>
            <span>
              {" "}
              - when a cryptocurrency has been purchased by more and more
              investors over time, with its price increasing for an extended
              period of time.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Oversold</b>
            <span>
              {" "}
              - when a cryptocurrency has been sold by more and more investors
              over time, with its price decreasing for an extended period of
              time.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-16@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Pair</b>
            <span>
              {" "}
              - Trade between one cryptocurrency and another, for example, the
              trading pair BTC/ETH.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Paper Trading (simulated trading) `}</b>
            <span>
              - is the practice of using a virtual transactional environment to
              simulate trading without the use of real capital. One of the best
              ways to practice strategies with financial reprecussions.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Paper Wallet</b>
            <span>
              {" "}
              - a physical document containing your private key or seed phrase.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Peer-to-Peer (P2P) `}</b>
            <span>
              - decentralized interactions between parties in a distributed
              network, partitioning tasks or workloads between peers.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Peg</b>
            <span>
              {" "}
              - is a specified price for the rate of exchange between two
              assets.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Pegged Currency `}</b>
            <span>
              - is a currency whose value is pegged to a real-world asset, such
              as a fiat currency. (an example can be stablecoin)
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Perpetual Contracts `}</b>
            <span>
              - is a derivative similar to a futures contract but without an
              expiry date.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Phishing `}</b>
            <span>
              - when a scammer pretends to be a trusted institution or person to
              trick people into revealing sensitive information such as Social
              Security numbers, passwords, banking details, etc., often through
              a malware link disguised as legitimate.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Phantom</b>
            <span>
              {" "}
              - Phantom is a software (Hot) wallet that we use for the Solana
              network, in order to make transactions using SOL to purchase NFTs.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Ponzi Scheme</b>
            <span>
              {" "}
              - a fraudulent investment involving the payment of purported
              returns to existing investors from funds contributed by new
              investors.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Portfolio `}</b>
            <span>
              - a collection of cryptocurrencies or crypto assets held by an
              investment company, hedge fund, financial institution, or
              individual.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Post-Mine</b>
            <span>
              {" "}
              - the creation of new coins following a cryptocurrency’s launch,
              before public mining is possible.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Pre-IDO</b>
            <span>
              {" "}
              - refers to token offerings before the actual initial DEX offering
              (IDO) takes place.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Pre-Mine `}</b>
            <span>
              - when some or all of a coin’s initial supply is generated during
              or before the public launch.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Pre-Sale</b>
            <span>
              {" "}
              - the sale of a cryptocurrency, ahead of it going public, to
              specific investors.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Private Blockchain `}</b>
            <span>
              - is a type of blockchain in which only a single organization has
              authority over the network.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Private Key/Secret Key `}</b>
            <span>
              - a piece of code generated in the asymmetric-key encryption
              process, paired with a public key, to be used in decrypting
              information hashed with the public key.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Proof-of-Authority (PoA) `}</b>
            <span>
              - a blockchain consensus mechanism that delivers comparatively
              fast transactions using identity as a stake.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Proof-of-Burn (PoB)</b>
            <span>
              {" "}
              - a blockchain consensus mechanism aiming to bootstrap one
              blockchain to another with increased energy efficiency, by
              verifying that a cost was incurred in “burning” a coin by sending
              it to an unspendable address.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Proof-of-Developer (PoD)</b>
            <span>
              {" "}
              - any verification that provides evidence of a real, living
              software developer who created a cryptocurrency, in order to
              prevent an anonymous developer from making away with any raised
              funds without delivering a working model.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Proof-of-Stake (PoS) `}</b>
            <span>
              - a blockchain consensus mechanism in addition to Proof-of-Work
              that maintains the integrity of blockchain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Proof-of-Validation `}</b>
            <span>
              - is a unique proof-of-stake (PoS) consensus mechanism that works
              to achieve consensus through staked validator nodes.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Proof-of-Work (PoW)</b>
            <span>
              {" "}
              - a blockchain consensus mechanism involving solving of
              computationally intensive puzzles to validate transactions and
              create new blocks.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Protocol `}</b>
            <span>
              - the set of rules that define interactions on a network, usually
              involving consensus, transaction validation, and network
              participation on a blockchain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Pseudonymous</b>
            <span>
              {" "}
              - writing under a false name such as “Satoshi Nakamoto.” (the fake
              name of the creator of Bitcoin)
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Public Address</b>
            <span>
              {" "}
              - a public address is the cryptographic hash of a public key,
              allowing the user to use it as an address to request for payment.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Public Sale `}</b>
            <span>
              - a public sale is the final stage of an ICO in which a company
              offers its token to the public at a significant discount before
              the token is listed on cryptocurrency exchanges.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Public-Key Cryptography</b>
            <span>
              {" "}
              - is a collection of algorithms-based cryptographic procedures
              that are used to jumble secret data and make it look randomized.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Public-Key Infrastructure (PKI)</b>
            <span>
              {" "}
              - is a collection of roles, rules, hardware, software, and
              processes for creating, managing, distributing, using, storing,
              and revoking digital certificates, as well as managing public-key
              encryption.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Pump and Dump (P&D) Scheme`}</b>
            <span>
              {" "}
              - a form of fraud involving the artificial inflation of the price
              of a cryptocurrency with false and misleading positive statements.
              There are a few notorious crypto groups that do this to
              artificially inflate crypto prices.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Put Option `}</b>
            <span>
              - a put option contract offers an owner the opportunity, but not
              the compulsion, to buy an underlying security at a certain price
              within a given time frame.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-18@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Raiden Network</b>
            <span>
              {" "}
              - an off-chain scaling solution aiming to enable near-instant,
              low-fee and scalable payments on the Ethereum blockchain, similar
              to Bitcoin's proposed Lightning Network.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Rank</b>
            <span>
              {" "}
              - the relative position of a cryptocurrency by market
              capitalization.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Rebalancing `}</b>
            <span>
              - is the process of realigning the weightage of a portfolio of
              assets, that involves buying or selling assets periodically to
              maintain a targeted level of asset allocation and risk.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Revenue</b>
            <span>
              {" "}
              - Revenue is the Sales Price for your product. E.G if you sell an
              NFT for $300, your revenue is $300.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Regulation `}</b>
            <span>
              - A rule or directive made and maintained by an authority. E.G the
              SEC or a government implementing regulation rules on the crypto
              market.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Roadmap</b>
            <span>
              {" "}
              - The planned future for a project. NFT projects will promote
              their roadmap to show their community what their plans are for the
              future.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Rebase</b>
            <span>
              {" "}
              - a token designed so that the circulating supply adjusts
              automatically according to price fluctuations.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Recovery Seed</b>
            <span>
              {" "}
              - is a cryptographically derived security code composed of a list
              of random words, typically ranging between 12 and 14.
            </span>
          </p>
          <p className="m-0">
            <b className="font-dm-sans">REKT</b>
            <span>
              {" "}
              - slang for “wrecked,” describing a bad loss in a trade.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Relative Strength Index (RSI)</b>
            <span>
              {" "}
              - a form of technical analysis that serves as a momentum
              oscillator, measuring the speed and change of price movements.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Relay Chain</b>
            <span>
              {" "}
              - is the central chain that is used by the Polkadot network.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Replicated Ledger `}</b>
            <span>
              - a copy of a distributed ledger in a network that is distributed
              to all participants in a cryptocurrency network.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Resistance (Line/Level) `}</b>
            <span>
              - the highest price level of an asset during a specific period.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Return On Investment (ROI) `}</b>
            <span>
              - the ratio between the net profit and cost of investing.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Rug Pull</b>
            <span>
              {" "}
              - is a type of scam where developers abandon a project and take
              their investors' money.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-19@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`S&P 500 (Standard and Poor's 500)`}</b>
            <span>
              {" "}
              - is a stock market index that represents a list of 500 public
              companies located in the U.S and their performance in the market.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Satoshi (SATS) `}</b>
            <span>
              - the smallest unit of bitcoin with a value of 0.00000001 BTC.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Satoshi Nakamoto</b>
            <span>
              {" "}
              - pseudonym used by the individual or group of individuals that
              created Bitcoin.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Second-Layer Solutions `}</b>
            <span>
              - a set of solutions built on top of a public blockchain to extend
              its scalability and efficiency, especially for micro-transactions
              or actions. Examples include Plasma, TrueBit, Lightning Network
              and more.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Secondary Market</b>
            <span>
              {" "}
              - is a place where investors or traders can buy and sell different
              kinds of assets or securities that they own, with others.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Securities and Exchange Commission (SEC)</b>
            <span>
              {" "}
              -an independent agency of the United States federal government,
              responsible for enforcing federal securities laws, proposing
              securities rules, and regulating the securities industry, the
              nation's stock and options exchanges, and other related activities
              and organizations.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Security</b>
            <span>
              {" "}
              - the term securities refers to a fungible and tradable financial
              instrument that carries a type of monetary value.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Security Token</b>
            <span>
              {" "}
              - is essentially a digital form of traditional securities.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Security Token Offering (STO)</b>
            <span>
              {" "}
              - is a public offering where tokenized digital securities are
              sold.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Seed Phrase</b>
            <span>
              {" "}
              - A single starting point when deriving keys for a deterministic
              wallet.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Sell Wall</b>
            <span>
              {" "}
              - a situation where a large limit order has been placed to sell
              when a cryptocurrency reaches a certain value.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Scam</b>
            <span>
              {" "}
              - A scam is an attempt to steal your assets e.g. NFTs. A scammer
              is someone who carries out a scam.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Shard `}</b>
            <span>
              - is a portion of a blockchain network that has been split into
              multiple shards, which has its own data.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Sharding `}</b>
            <span>
              - is a scaling approach that enables splitting of blockchain
              states into partitions containing states and transaction history,
              so that each shard can be processed in parallel.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Shilling</b>
            <span>
              {" "}
              - The act of blatantly promoting a cryptocurrency or ICO project.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Shitcoin</b>
            <span> - a coin with no obvious potential value or usage.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">SHO (Strong Holder Offering)</b>
            <span>
              {" "}
              - is a fundraising mechanism where eligible investors are chosen
              based on their on-chain activities and other proprietary data
              sets.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Short</b>
            <span>
              {" "}
              - a trading technique in which a trader borrows an asset in order
              to sell it, with the expectation that the price will continue to
              decline. In the event that the price does decline, the short
              seller will then buy the asset at this lower price in order to
              return it to the lender of the asset, making the difference in
              profit.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Signal `}</b>
            <span>
              - Signals are a call to action to either buy or sell an asset.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Slashing</b>
            <span>
              {" "}
              - an event where the validator forfeits a defined proportion of
              staked tokens, which are then burned or redistributed to other
              stakeholders.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Slippage</b>
            <span>
              {" "}
              - when traders have to settle for a different price than what they
              initially requested due to a price movement.
            </span>
          </p>
          <p className="m-0">
            Smart Contract - a smart contract is a computer protocol intended to
            facilitate, verify or enforce a contract on the blockchain without
            third parties.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Smart Contract Audit</b>
            <span>
              {" "}
              - a smart contract audit is a security check done by 3rd party
              cybersecurity professionals to ensure that the on-chain code
              behind a smart contract is clear of bugs or security
              vulnerabilities.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Soft Cap</b>
            <span>
              {" "}
              - the minimum amount that an initial coin offering (ICO) wants to
              raise.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Soft Fork (Blockchain)</b>
            <span>
              {" "}
              - a protocol upgrade where only previously valid transactions are
              made invalid, with most soft forks requiring miners to upgrade
              their mining software.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Solidity</b>
            <span>
              {" "}
              - the programming language used by Ethereum for developing smart
              contracts.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Spot Trade</b>
            <span>
              {" "}
              - a contract or transaction buying or selling a cryptocurrency for
              immediate settlement, or payment and delivery, of the
              cryptocurrency on the market.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Spot Market</b>
            <span>
              {" "}
              - a public market in which cryptocurrencies are traded for
              immediate settlement. It contrasts with a futures market, in which
              settlement is due at a later date.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Stablecoin</b>
            <span>
              {" "}
              - a cryptocurrency with extremely low volatility, sometimes used
              as a means of portfolio diversification. Examples include
              gold-backed cryptocurrency or fiat-pegged cryptocurrency.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Staking `}</b>
            <span>
              - participation in a proof-of-stake (PoS) system to put your
              tokens in to serve as a validator to the blockchain and receive
              rewards.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Staking Pool</b>
            <span>
              {" "}
              - allows users to combine their resources in order to increase
              their chances of earning rewards. This mechanism offers more
              staking power to the network to verify and validate new blocks.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Standard Lot Size `}</b>
            <span>- represents 100,000 units of a cryptocurrency</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Stochastic Oscillator</b>
            <span>
              {" "}
              - is a popular technical indicator used for identifying overbought
              and oversold stock/asset/cryptocurrency levels that rely on an
              asset's price history, as it tend to fluctuate within a specific
              price range.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Stop-Loss Order</b>
            <span>
              {" "}
              - a stop-loss order in trading allows investors to determine the
              lowest price at which they are willing to sell an asset and
              trigger an automatic sell order when and if this price is reached.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Storage (Decentralized)</b>
            <span>
              {" "}
              - refers to the concept of storing files online by splitting them
              into encrypted fragments and delegating these fragments to
              multiple nodes on a distributed network like a blockchain
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Storage Miners</b>
            <span>
              {" "}
              - are cryptocurrency miners who rely on offering sufficient
              storage space for nodes to reach consensus and validate
              transactions.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Store of Value</b>
            <span>
              {" "}
              - a store of value is an asset, commodity or currency that can be
              saved, retrieved as well as exchanged in the future without it
              losing any value.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Swing Trading</b>
            <span>
              {" "}
              - is a market trading technique that aims to profit from short to
              medium-term price changes in stocks, commodities, and/or
              currencies over a period of days or weeks.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Symbol</b>
            <span>
              {" "}
              - the ticker of a cryptocurrency; for example, Bitcoin's symbol is
              BTC.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-20@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Taint</b>
            <span>
              {" "}
              - the percentage of cryptocurrency in an account that can be
              traced to another account.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Technical Analysis/Trend Analysis (TA) `}</b>
            <span>
              - evaluation methods involving statistical analyses of market
              activity, such as price and volume. Charts and other tools are
              used to identify patterns to underpin and drive investment
              decisions.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Technical Indicators</b>
            <span>
              {" "}
              - is a statistical algorithm or pattern-based indication based on
              a security's or contract's historical price, volume, and/or open
              interest.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">The DAO</b>
            <span>
              {" "}
              - the first decentralized autonomous organization, which was
              created by a group of developers in April 2016.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Think Long Term (TLT)</b>
            <span>
              {" "}
              - mindset where you have a longer-term investment horizon of
              months to years.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Ticker</b>
            <span>
              {" "}
              - an abbreviation used to uniquely identify cryptocurrencies.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Ticker Symbol</b>
            <span>
              {" "}
              - is the unique combination of letters assigned to stocks or
              cryptocurrencies that makes them distinguishable on exchanges and
              other trading applications.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Token</b>
            <span>
              {" "}
              - a digital unit designed with utility in mind, providing access
              and use of a larger crypto economic system.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Token Economy</b>
            <span>
              {" "}
              - an economy of goods and services that can run without
              intermediaries and third parties with the help of the blockchain
              technology.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Token Issuance</b>
            <span>
              {" "}
              - is the process of creating new tokens and adding them to the
              total token supply of a cryptocurrency
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Token Sale</b>
            <span>
              {" "}
              - refers to the initial offering of a cryptocurrency token to a
              private pool of investors before it officially goes on the market.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Token Swap `}</b>
            <span>- refers to one of two things:</span>
          </p>
          <p className="m-0">
            1.) Direct exchange of a certain amount of one cryptocurrency token
            for another between users facilitated by a special exchange service.
          </p>
          <p className="m-0">
            2.) Migration of a cryptocurrency token built on top of one
            blockchain platform to a different blockchain.
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Tokenize</b>
            <span>
              {" "}
              - the process by which real-world assets are turned into something
              of digital value called a token, often subsequently able to offer
              ownership of parts of this asset to different owners.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Tokenomics</b>
            <span>
              {" "}
              - is the science of token economy which consists of a set of rules
              that governs a cryptocurrency's issuance and supply.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Total Supply `}</b>
            <span>
              - the total amount of coins in existence right now, minus any
              coins that have been verifiably burned.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Total Value Locked (TVL)</b>
            <span>
              {" "}
              - total value locked represents the number of assets that are
              currently being staked in a specific protocol.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Trade Volume `}</b>
            <span>
              - the amount of the cryptocurrency that has been traded in the
              last 24 hours.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Trading Bot</b>
            <span>
              {" "}
              - a crypto trading bot is essentially a program that is designed
              to automate cryptocurrency asset trading on the behalf of the
              trader.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Trading Pair</b>
            <span>
              {" "}
              - a function whereby you have two different currencies that can be
              traded between one another. If you're looking to buy or sell
              Bitcoin with U.S. Dollar, the trading pair would be BTC to USD.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Trading Volume</b>
            <span>
              {" "}
              - refers to the total number of shares (or tokens/coins) that have
              been exchanged between buyers and sellers of a given asset during
              trading hours of a certain day.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Transaction (TX) `}</b>
            <span>
              - The act of exchanging cryptocurrencies on a blockchain.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Transaction Fee</b>
            <span> - payment for using the blockchain to transact.</span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Two-Factor Authentication (2FA)</b>
            <span>
              {" "}
              - is method of access that requires two different forms of
              authentication.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-21@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Unconfirmed `}</b>
            <span>
              - state in which a transaction has not been appended to the
              blockchain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Unpermissioned Ledger</b>
            <span>
              {" "}
              - public ledger that is open to anyone, without being controlled
              by a single owner.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Unspent Transaction Output (UTXO)</b>
            <span>
              {" "}
              - transaction that is left unspent after being completed, similar
              to leftover change after making a purchase.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Utility Token</b>
            <span>
              {" "}
              - are designed specifically to be able to help people use
              something.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-22@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">{`Validator `}</b>
            <span>
              - participant on a proof-of-stake (PoS) blockchain, involved in
              validating blocks for rewards.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Vanity Address</b>
            <span>
              {" "}
              - cryptocurrency public address with custom letters and numbers,
              usually picked by its owner.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Virtual Automated Market Makers (vAMMs) `}</b>
            <span>
              - is a system that provides synthetic (or virtual) liquidity,
              allowing traders to buy and sell derivatives entirely on the
              blockchain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Vitalik Buterin `}</b>
            <span>
              - one of the creators of Ethereum, the second-largest
              cryptocurrency after Bitcoin.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Volatility `}</b>
            <span>
              - statistical measure of dispersion of returns, measured by using
              the standard deviation or variance between returns from that same
              security or market index.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Volume `}</b>
            <span>
              - the amount of cryptocurrency that has been traded over a set
              period (e.g 24 hours)
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-23@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Wallet</b>
            <span>
              {" "}
              - place where cryptocurrency users can store, send and receive
              digital assets.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Wash Trade</b>
            <span>
              {" "}
              - a form of market manipulation in which investors create
              artificial activity in the marketplace by simultaneously selling
              and buying the same cryptocurrencies.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Watchlist</b>
            <span>
              {" "}
              - usually refers to a feature of the website where users can
              create their own lists of cryptocurrencies to follow.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Web 1.0 `}</b>
            <span>
              - a term that is often used to describe the early version of the
              internet.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Web 2.0</b>
            <span>
              {" "}
              - describes the current state of the web, which supports more
              user-generated content and stability for front-end users than Web
              1.0.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Web 3.0</b>
            <span>
              {" "}
              - refers to a decentralized online ecosystem based on the
              blockchain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Web3 Foundation</b>
            <span>
              {" "}
              - was created to foster new technologies and applications in the
              field of decentralized web software protocols.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Wei `}</b>
            <span>
              - the smallest fraction of an Ether, with each Ether to
              1000000000000000000 Wei.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Whale</b>
            <span>
              {" "}
              - term used to describe investors who have uncommonly large
              amounts of crypto, especially those with enough funds to
              manipulate the market.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Whitelist `}</b>
            <span>
              - a list of interested participants in an initial coin offering,
              who registered their intent to take part or purchase in a sale.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Whitepaper `}</b>
            <span>
              - document released by a crypto project that gives investors
              technical information about its concept, and a roadmap for how it
              plans to grow and succeed.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Winding Down</b>
            <span>
              {" "}
              - is the process of unwrapping tokens back to their original form
              in DeFi.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Winding Up</b>
            <span>
              {" "}
              - process of wrapping crypto tokens through various projects in
              order to find the best yield.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-25@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">Yield Farming</b>
            <span>
              {" "}
              - involves earning interest by investing crypto in decentralized
              finance markets.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">Year To Date (YTD)</b>
            <span>
              {" "}
              - commonly found in charts and historic price data as a filter.
            </span>
          </p>
        </div>
        <img
          className="relative w-[93.88rem] h-[17.06rem] object-cover"
          alt=""
          src="/23-unity-alphabet-banner-a-26@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b className="font-dm-sans">
              Zero Confirmation/Unconfirmed Transaction
            </b>
            <span>
              {" "}
              - defined as an transaction that has not yet been recorded or
              verified on the blockchain.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Zero Knowledge Proof `}</b>
            <span>
              - Proving certain information or data is true without revealing
              it.
            </span>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            <b className="font-dm-sans">{`Zero Knowledge Rollups `}</b>
            <span>
              - is a Layer 2 blockchain solution that performs computations and
              storage off-chain while funds are held in a smart contract.
            </span>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>{`Zero-Knowledge Proof `}</b>
            <span>
              - enables one party to provide evidence that a transaction or
              event happened without revealing private details of that
              transaction or event.
            </span>
          </p>
        </div>
      </div>
      <a href="https://unityacademy.io/dashboard" className="no-underline">
      <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
        <b className="self-stretch relative no-underline text-white">Next Chapter</b>
      </div>
      </a>
    </div>
  );
};

export default Dictionary;
